import { gsap } from "gsap"

// Header menu — burger toggle, close, scroll-to-top, go-to-quiz
export function initMenu(quiz = null) {
    const burger = document.querySelector(".site__burger")
    const menu = document.querySelector(".site__menu")
    const closeBtn = document.querySelector(".site__menu-close")
    const links = document.querySelectorAll(".site__menu-link, .site__title[data-action]")

    if (!burger || !menu) return

    // Open menu
    burger.addEventListener("click", () => {
        menu.classList.add("is-open")
        menu.setAttribute("aria-hidden", "false")
        burger.setAttribute("aria-expanded", "true")
        document.body.style.overflow = "hidden"
    })

    // Close menu helper
    const closeMenu = () => {
        menu.classList.remove("is-open")
        menu.setAttribute("aria-hidden", "true")
        burger.setAttribute("aria-expanded", "false")
        document.body.style.overflow = ""
    }

    // Close button
    if (closeBtn) {
        closeBtn.addEventListener("click", closeMenu)
    }

    // Close on link click
    links.forEach((link) => {
        link.addEventListener("click", (e) => {
            const action = link.dataset.action
            const targetId = link.hash?.slice(1)
            if (targetId) {
                e.preventDefault()
                closeMenu()
                // Jump to the requested section and enforce its position as the upper boundary.
                if (quiz) {
                    quiz.enterInfosMode(targetId)
                } else {
                    document.getElementById(targetId)?.scrollIntoView({ behavior: "auto" })
                }
            } else if (action === "scroll-top") {
                e.preventDefault()
                closeMenu()
                // Scroll to first screen using quiz.scrollTo if available
                if (quiz) {
                    quiz.exitInfosMode()
                    quiz.locked = false
                    quiz.isAnimating = false
                    gsap.killTweensOf(window)
                    quiz.scrollTo(0, 'forward')
                } else {
                    window.scrollTo({ top: 0, behavior: "smooth" })
                }
            } else if (action === "go-quiz") {
                e.preventDefault()
                closeMenu()
                // Restart the quiz — reset progress and scroll to first question, mirroring .quiz__restart
                if (quiz) {
                    quiz.restart()
                } else {
                    const firstQuestion = document.querySelector('[data-screen-type="question"]')
                    if (firstQuestion) {
                        firstQuestion.scrollIntoView({ behavior: "smooth" })
                    }
                }
            } else {
                closeMenu()
            }
        })
    })

    // Close on Escape key
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && menu.classList.contains("is-open")) {
            closeMenu()
        }
    })
}
